<div class="{{ OBJ_LNG_NAME }} chooseImage width100">

    <h1 mat-dialog-title>
        {{  'allgemein.auswählen' | translate:locale.language:{ typ: (nurBild ? 'bild.typ' : 'DATEI.typ') | translate:locale.language } }}
        <button mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button>
        <mat-progress-bar *ngIf="seconddialogrunningajaxcall" color="primary" mode="indeterminate"></mat-progress-bar>
    </h1>

    <mat-dialog-content>

		<mat-progress-bar *ngIf="seconddialogrunningajaxcall" color="primary" mode="indeterminate"></mat-progress-bar>
		<form *ngIf="aktuellDateien" #chooseImageForm="ngForm" class="{{ OBJ_LNG_NAME }} chooseImageForm">
			<p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>

			<div class="imgchoosecontainer">
				<div fxLayout="row wrap" fxLayoutAlign="stretch" fxFlex>
					<div fxFlex="1 1 33%" fxLayoutAlign="stretch" *ngFor="let bild of aktuellDateien">
						<mat-card appearance="outlined">
							<mat-card-header>
								<mat-card-title>{{ bild.name }}</mat-card-title>
								<mat-card-subtitle>{{ bild.breite }} X {{ bild.hoehe }}</mat-card-subtitle>
							</mat-card-header>
							<img mat-card-image class="loading" [src]="getBildVerkleinertUrl(bild, '/w250')">
							<mat-card-actions>
								<button mat-raised-button color="primary" mat-dialog-close (click)="setDatei(bild)">{{ 'allgemein.auswählen' | translate:locale.language:{ typ: 'bild.typ' | translate:locale.language } }}</button>
							</mat-card-actions>
						</mat-card>
					</div>
				</div>
			</div>
		</form>

    </mat-dialog-content>

</div>

